import { takeLatest } from 'redux-saga/effects';
import history from '../history';

function* handleRedirect(action: { url: string }) {
  history.push(action.url);
}

function* redirect() {
  yield takeLatest('REDIRECT' as any, handleRedirect);
}

export default redirect;
